import { z } from 'zod'

const positiveNumber = z.coerce.number().positive('Must be > 0')

export const newBasketSettingsSchema = z.object({
	groupBy: z.string(),
	switchDirectDeals: z.boolean(),
	highVolumeMfr: z.object({
		enabled: z.boolean(),
		cases: positiveNumber,
		spend: positiveNumber,
	}),
	restrictedManufacturer: z.boolean(),
	sameManufacturer: z.boolean(),
	preferExactMatch: z.boolean(),
	programs: z.object({
		direct: z.boolean(),
		beBrandExtendable: z.boolean(),
		bePlatform: z.boolean(),
		entegra: z.boolean(),
	}),
	savingsMoreThan: z.object({
		type: z.string(),
		value: positiveNumber,
	}),
	packSize: z.object({
		low: positiveNumber,
		high: positiveNumber,
	}),
	caseQty: z.object({
		enabled: z.boolean(),
		value: positiveNumber,
	}),
	estimatedFob: z.object({
		enabled: z.boolean(),
		value: positiveNumber,
	}),
	annualizationMonths: z.coerce
		.number()
		.min(0.5, 'Must be at least 0.5')
		.max(12, 'Must be at most 12')
		.refine((v) => v % 0.5 === 0, 'Must be in 0.5 increments'),
})

export const updateBasketSettingsSchema = newBasketSettingsSchema.extend({
	tier: z.string(),
	ignoreCustomersWithInvalidTiers: z.boolean(),
})
